import {LavoratorePresenzeProprietaRecord} from "@commons/mapping/LavoratorePresenzeProprietaRecord";
import {TabellePresenze} from "@commons/mapping/TabellePresenze";
import {ControlloAccumulo} from "@commons/mapping/GiustificazioneAutoRecord";
import {LavoratoreULRecord} from "@commons/mapping/LavoratoreULRecord";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";

export type TipoChiusuraPresenze = "MENSILE" | "SETTIMANALE" | null;
export type TipoRilevazionePresenze = "MANUALE" | "TRAMITE_BADGE" | "MISTA" | null;

export interface LavoratorePresenzeProprietaULRecord extends LavoratorePresenzeProprietaRecord {
    idAzienda: number;
    idCalendario: number;
    idCalendarioWF: number;
    tabelleUL: TabellePresenze | null;
    tipoChiusuraPresenze: TipoChiusuraPresenze;
    tipoRilevazione: TipoRilevazionePresenze;
    codGiuMalattiaTemp: string;
    codGiuMalattia: string;
    codGiuMalattiaRicaduta: string;
    codGiuMalattiaNC: string;
    codStatusRicovero: string;
    controlloAccumuloML: ControlloAccumulo;
    codiceAccumuloML: string;
    codGiuSpecificaOD: string;
    codGiuSpecificaON: string;
    lavoratoreULRecord: LavoratoreULRecord | null;
}

export class LavoratorePresenzeProprietaULRecord {
    static factory: ObjectFactory<LavoratorePresenzeProprietaULRecord> = (json?) => {
        return merge<LavoratorePresenzeProprietaULRecord, Partial<LavoratorePresenzeProprietaULRecord> | undefined>({
            codiceFiscale: '',
            idAziendaMaster: 0,
            idDip: 0,
            decorrenza: null,
            tipoGestione: 'NON_GESTITO',
            quantitaTimbrature: 'COME_DA_ORARIO',
            tabelle: null,
            lavorazioneCodGiu1: '',
            lavorazioneCodGiu2: '',
            lavorazioneCodGiu3: '',
            lavorazioneSoglia1: 0,
            lavorazioneSoglia2: 0,
            chiudiAlloSviluppo: false,
            insertTrace: undefined,
            lastUpdateTrace: undefined,

            idAzienda: 0,
            idCalendario: 0,
            idCalendarioWF: 0,
            tabelleUL: null,
            tipoChiusuraPresenze: null,
            tipoRilevazione: null,
            codGiuMalattiaTemp: '',
            codGiuMalattia: '',
            codGiuMalattiaRicaduta: '',
            codGiuMalattiaNC: '',
            codStatusRicovero: '',
            controlloAccumuloML: 'NESSUN_CONTROLLO',
            codiceAccumuloML: '',
            codGiuSpecificaOD: '',
            codGiuSpecificaON: '',
            lavoratoreULRecord: null,
            URI: null,
        }, json);
    }

    static getTabelle = function (that: LavoratorePresenzeProprietaULRecord, turno: TurnoRecord) {
        const tabella = TabellePresenze.factory();
        const prop: (keyof TabellePresenze)[] = [
            'idTabEccedentiQuali',
            'idTabEccedentiQuanti',
            'idTabTurniAlt',
            'idTabGiuRicorrenti',
            'idTabFlex',
            'idTabTolleranza',
            'idTabFasciaDiurna',
            'idTabFasciaCompetenza'];
        const propPriority: (keyof TabellePresenze)[] = [
            'tabEccedentiQualiPriority',
            'tabEccedentiQuantiPriority',
            'tabTurniAltPriority',
            'tabGiuRicorrentiPriority',
            'tabFlexPriority',
            'tabTolleranzaPriority',
            'tabFasciaDiurnaPriority',
            'tabFasciaCompetenzaPriority'];
        if (that.tabelle && turno.tabelle)
            for (let ind0 = 0; ind0 < prop.length; ++ind0) {
                // Valuto tabelle lavoratore
                if (that.tabelle[prop[ind0]] !== 0) {
                    // assegno tabella azienda solo se valorizzata e prioritaria
                    if (turno.tabelle[prop[ind0]] !== 0 && turno.tabelle[propPriority[ind0]] !== 0) {
                        tabella[prop[ind0]] = turno.tabelle[prop[ind0]];
                    } else {
                        tabella[prop[ind0]] = that.tabelle[prop[ind0]];
                    }
                }
                // Valuto tabelle turno
                else if (turno.tabelle[prop[ind0]] !== 0) {
                    tabella[prop[ind0]] = turno.tabelle[prop[ind0]];
                }
                // Valuto tabelle azienda
                else if (that.tabelleUL) {
                    tabella[prop[ind0]] = that.tabelleUL[prop[ind0]];
                }
            }
        return tabella;
    };

    static getDescTipologiaGestione = function (that: LavoratorePresenzeProprietaULRecord | null) {
        if (that)
            switch (that.tipoGestione) {
                case 'GESTITO':
                    return 'Gestito';
                case 'GESTITO_NO_INAIL':
                    return 'Non gestito Inail';
                case 'NO_RILEVAZIONE':
                    return 'Nessuna rilevazione';
                case 'NON_GESTITO':
                    return 'Non gestito';
                default:
                    return '???';
            }
        else return '???'
    }
    static getDescQuantitaTimb = function (that: LavoratorePresenzeProprietaULRecord | null) {
        if (that)
            switch (that.quantitaTimbrature) {
                case 'COME_DA_ORARIO':
                    return `In base all'orario turno`;
                case 'UNA':
                    return 'Una timbratura';
                case 'DUE':
                    return 'Due timbrature';
                case 'DUE_ENTRATE':
                    return 'Due timbrature (solo entrata)';
                case 'CON_O_SENZA':
                    return 'Con o senza timbrature';
                case 'A_CONSUNTIVO':
                    return 'Con o senza timbrature (a consuntivo)';
                default:
                    return '???';
            }
        else return '???'
    }
}